/**
 * macOSテーマを適用すべきルートかどうかを判定する純粋関数
 *
 * 設計方針 (L-B5):
 * - 個別 feature 名のハードコードは本ファイルに残さず、
 *   `theme-exclude-defaults.ts` に分離（呼び出し側からの注入も可能）
 * - 呼び出し側で除外リストを差し替えたい場合は `options` 引数で注入する
 * - `options` 省略時は default リストを使用（既存呼び出しの後方互換性維持）
 *
 * 除外対象（default）の詳細は `theme-exclude-defaults.ts` 参照。
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-B5
 */

import {
  DEFAULT_THEME_EXCLUDE_PREFIXES,
  DEFAULT_THEME_EXCLUDE_EXACT,
} from './theme-exclude-defaults'

export interface ThemeExcludeOptions {
  /** テーマを適用しない prefix（前方一致、末尾スラッシュ前提）。省略時は default を使用 */
  excludePrefixes?: readonly string[]
  /** テーマを適用しないパス（完全一致）。省略時は default を使用 */
  excludeExactPaths?: readonly string[]
}

export function shouldApplyMacOsTheme(
  pathname: string,
  options?: ThemeExcludeOptions,
): boolean {
  const excludeExact = options?.excludeExactPaths ?? DEFAULT_THEME_EXCLUDE_EXACT
  const excludePrefixes = options?.excludePrefixes ?? DEFAULT_THEME_EXCLUDE_PREFIXES

  // 完全一致チェック
  if (excludeExact.includes(pathname)) {
    return false
  }
  // プレフィックス一致チェック（セグメント境界で区切られた場合のみ）
  for (const prefix of excludePrefixes) {
    if (pathname.startsWith(prefix)) {
      return false
    }
  }
  return true
}
